import {CardContent, CardHeader} from '@mui/material'
import {PropsWithChildren} from 'react'
import {CardCustomStyle} from './CardCustomStyle'

type CardCustomProps = {
    title: React.ReactNode,
    style?: React.CSSProperties
}

const CardCustom: React.FC<PropsWithChildren<CardCustomProps>> = ({title, children, style}) => {
  return (
    <CardCustomStyle style={style}>
      <CardHeader title={title} />
      <CardContent>
        {children}
      </CardContent>
    </CardCustomStyle>
  )
}

export default CardCustom
